import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {FC} from "react";
import styled from "styled-components";
import { Endpoints, TFile } from "@brg/api";
import {LayoutConst} from "../../../core";

const OverflowContainer = styled.div<{selected?: boolean}>`
  overflow: hidden;
  width: fit-content;
  height: max-content;
  cursor: pointer;
  position: relative;

  border: 2px solid ${({selected}) => selected ? '#146DEE' : 'transparent'};
`

const ShopImage = styled.div<{isSmall?: boolean}>`
  display: flex;
  flex-grow: 1;
  background: #F2F2F2;
  align-items: center;
  justify-content: center;

  width: 127px;
  height: 127px;
  min-height: 127px;
  max-height: 127px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 127px;
    height: 127px;
    min-height: 127px;
    max-height: 127px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    // height: calc((50vw - 15px));
    // min-height: calc((50vw - 15px));
    // max-height: calc((50vw - 15px));
    // width: calc(50vw - 15px);

    width: 127px;
    height: 127px;
    min-height: 127px;
    max-height: 127px;
  }
  
  img {
    max-height: 100%;
    max-width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: calc((33.3vw - 15px));
    min-height: calc((33.3vw - 15px));
    max-height: calc((33.3vw - 15px));
    width: calc(33.3vw - 15px);
  }
`


const QualityElement = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  border-radius: 3px;
  background: rgba(21, 21, 20, 0.40);
  backdrop-filter: blur(2px);
  text-align: center;
  padding: 2px 8px;

  font-size: 10px;
  font-weight: 500;
  line-height: 13px;
  color: #fefefe;
`

export const ImageCard: FC<{selected?: boolean, quality?: number, images?: TFile[], customClick?: () => void }> = (props) => {

    const {
        selected = false,
        quality = 0,
        images = [],
        customClick = () => {}
} = props

    const [image, ref] = useResizedImageEnhanced(images);

    return (<OverflowContainer selected={selected} ref={ref} onClick={customClick}>
        <ShopImage>{image?.url && <img src={`${Endpoints.files}/${image?.url}`} alt=""/>}</ShopImage>
        {quality > 0 && <QualityElement>A{6 - quality}</QualityElement>}
    </OverflowContainer>)
}import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import {FC} from "react";
import styled from "styled-components";
import { Endpoints, TFile } from "@brg/api";
import {LayoutConst} from "../../../core";

const OverflowContainer = styled.div<{selected?: boolean}>`
  overflow: hidden;
  width: fit-content;
  height: max-content;
  cursor: pointer;
  position: relative;

  border: 2px solid ${({selected}) => selected ? '#146DEE' : 'transparent'};
`

const ShopImage = styled.div<{isSmall?: boolean}>`
  display: flex;
  flex-grow: 1;
  background: #F2F2F2;
  align-items: center;
  justify-content: center;

  width: 127px;
  height: 127px;
  min-height: 127px;
  max-height: 127px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 127px;
    height: 127px;
    min-height: 127px;
    max-height: 127px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    // height: calc((50vw - 15px));
    // min-height: calc((50vw - 15px));
    // max-height: calc((50vw - 15px));
    // width: calc(50vw - 15px);

    width: 127px;
    height: 127px;
    min-height: 127px;
    max-height: 127px;
  }
  
  img {
    max-height: 100%;
    max-width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: calc((33.3vw - 15px));
    min-height: calc((33.3vw - 15px));
    max-height: calc((33.3vw - 15px));
    width: calc(33.3vw - 15px);
  }
`


const QualityElement = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  border-radius: 3px;
  background: rgba(21, 21, 20, 0.40);
  backdrop-filter: blur(2px);
  text-align: center;
  padding: 2px 8px;

  font-size: 10px;
  font-weight: 500;
  line-height: 13px;
  color: #fefefe;
`

export const ImageCard: FC<{selected?: boolean, quality?: number, images?: TFile[], customClick?: () => void }> = (props) => {

    const {
        selected = false,
        quality = 0,
        images = [],
        customClick = () => {}
} = props

    const [image, ref] = useResizedImageEnhanced(images);

    return (<OverflowContainer selected={selected} ref={ref} onClick={customClick}>
        <ShopImage>{image?.url && <img src={`${Endpoints.files}/${image?.url}`} alt=""/>}</ShopImage>
        {quality > 0 && <QualityElement>A{6 - quality}</QualityElement>}
    </OverflowContainer>)
}